import { relations } from 'drizzle-orm';
import { char, index, jsonb, pgTable, serial, timestamp, uniqueIndex, varchar } from 'drizzle-orm/pg-core';
import { type TypeId, typeIdDataType as typeId } from '../utils/typeid';
import { account } from './account';
import { eventsToEndpoints } from './event-to-endpoint';
import { webhookConversation } from './webhook-conversation';

export const EVENT_TYPES = [
  'account.status.disconnected',
  'account.status.running',
  'account.status.errored',
  'account.status.degraded',
  'account.status.partial',
  'account.locked',
  'account.unlocked',
  'account.add',
  'account.reconnect',
  'account.remove',
  'account.initial_sync.running',
  'account.initial_sync.failed',
  'account.initial_sync.completed',
  'message.new',
  'message.update',
  'message.delete',
  'message.receipt.read',
  'message.receipt.delivery',
  'message.reaction.new',
  'message.reaction.delete',
  'chat.delete',
  'chat.update',
  'email.new',
  'email.new.bounce',
  'email.update',
  'email.delete',
  'email.draft.new',
  'email.draft.delete',
  'email.folder.create',
  'email.folder.update',
  'email.folder.delete',
  'calendar.create',
  'calendar.update',
  'calendar.delete',
  'calendar.event.new',
  'calendar.event.update',
  'calendar.event.delete',
  'tracking.open',
  'tracking.click',
  'relation.new',
  'follower.new',
  'blocked.new',
] as const;

export const event = pgTable(
  'event',
  {
    id: serial().primaryKey(),
    public_id: typeId('event', 'public_id').notNull(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    type: varchar({ length: 255 }).notNull().$type<(typeof EVENT_TYPES)[number]>(),
    payload: jsonb().notNull().$type<{
      [x: string]: unknown;
    }>(),
    hash: varchar({ length: 64 }).notNull().unique('hash_unique'),
    account_public_id: typeId('account', 'account_public_id').notNull(),
    account_scope_id: char({ length: 32 }).$type<TypeId<'accountScope'>>(),
  },
  (t) => [
    uniqueIndex('event_public_id_uq').on(t.public_id),
    index('event_created_at_idx').on(t.created_at),
    index('event_account_public_id_idx').on(t.account_public_id),
  ],
);

export const eventsRelations = relations(event, ({ many, one }) => ({
  eventsToEndpoints: many(eventsToEndpoints),
  webhookConversations: many(webhookConversation),
  account: one(account, {
    fields: [event.account_public_id],
    references: [account.public_id],
  }),
}));
